import { useState } from 'react'

export interface Step {
  name: string
  showNavigation?: boolean
  hideClose?: boolean
}

const useUploadModal = (steps: Step[]) => {
  const [stepIndex, setStepIndex] = useState(0)

  const handleStepBack = () => {
    if (stepIndex < 1) {
      return
    }

    setStepIndex((prev) => prev - 1)
  }

  const handleStepForward = () => {
    if (stepIndex >= steps.length) {
      return
    }

    setStepIndex((prev) => prev + 1)
  }

  return {
    stepIndex,
    setStepIndex,
    handleStepBack,
    handleStepForward
  }
}

export default useUploadModal
